import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export const useEnvironmentVariables = () => {
  const page = usePage()

  const streamApiKey = computed(() => page.props.envs.streamApiKey)
  const streamBaseUrl = computed(() => page.props.envs.streamBaseUrl)
  const streamAppId = computed(() => page.props.envs.streamAppId)
  const teamMaxSeats = computed(() => page.props.envs.teamMaxSeats)
  const recaptchaSiteKey = computed(() => page.props.envs.recaptchaSiteKey)
  const crispEnabled = computed(() => page.props.envs.crispEnabled)
  const bonjoroEnabled = computed(() => page.props.envs.bonjoroEnabled)
  const bonjoroAppId = computed(() => page.props.envs.bonjoroAppId)
  const openaiMatchingEnabled = computed(
    () => page.props.envs.openaiMatchingEnabled,
  )
  const minimumReferralPayoutAmount = computed(
    () => page.props.envs.minimumReferralPayoutAmount,
  )

  return {
    streamApiKey,
    streamBaseUrl,
    streamAppId,
    teamMaxSeats,
    recaptchaSiteKey,
    crispEnabled,
    bonjoroEnabled,
    bonjoroAppId,
    openaiMatchingEnabled,
    minimumReferralPayoutAmount,
  }
}
